import { tassign } from 'tassign';
import { UserRoleState, initialUserRoleState } from './user-role-state.model';
import { Action, UserRoleActions } from './user-role-actions';

/**
* @functions AdminReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
* @return tassing<AdminReducer> Value with the store
**/
export const UserRoleReducer = function (state: UserRoleState = initialUserRoleState, action: Action): UserRoleState {
  switch (action.type) {
    case UserRoleActions.SET_UPDATE:
      return tassign(state, {
        updateRole: action.payload.updateRole,
        userRoles: action.payload.userRoles,
        roleList: action.payload.roleList
      });
    case UserRoleActions.RESET_UPDATE:
      return tassign(state, initialUserRoleState);
    default:
      return state;
  }
};


